import type { ExportDocxOptions } from "@tiptap-pro/extension-export-docx";

export type TiptapSharedExportOptions = Pick<
  ExportDocxOptions,
  | "pageMargins"
  | "paragraphOverrides"
  | "styleOverrides"
  | "tableCellOverrides"
  | "tableOverrides"
  | "textRunOverrides"
>;

const TABLE_BORDER = {
  style: "single",
  color: "D0D7DE",
  size: 4,
} as const;

const DOCX_PAGE_MARGINS = {
  top: "1in",
  right: "1in",
  bottom: "1in",
  left: "1in",
  header: "0.5in",
  footer: "0.5in",
} as const;

const DOCX_TEXT_RUN = {
  font: "Arial",
  size: 22,
  color: "111827",
} as const;

export const TIPTAP_SHARED_EXPORT_OPTIONS = {
  pageMargins: DOCX_PAGE_MARGINS,
  paragraphOverrides: {
    alignment: "left",
    spacing: {
      after: 120,
    },
  },
  styleOverrides: {
    default: {
      document: {
        run: {
          font: "Arial",
          size: 22,
          color: "111827",
        },
        paragraph: {
          spacing: {
            after: 120,
          },
        },
      },
      heading1: {
        run: { bold: true, size: 36, color: "111827" },
        paragraph: { spacing: { before: 240, after: 160 } },
      },
      heading2: {
        run: { bold: true, size: 32, color: "111827" },
        paragraph: { spacing: { before: 220, after: 140 } },
      },
      heading3: {
        run: { bold: true, size: 28, color: "111827" },
        paragraph: { spacing: { before: 200, after: 120 } },
      },
      heading4: {
        run: { bold: true, size: 24, color: "111827" },
        paragraph: { spacing: { before: 180, after: 100 } },
      },
      heading5: {
        run: { bold: true, size: 22, color: "111827" },
        paragraph: { spacing: { before: 160, after: 80 } },
      },
      heading6: {
        run: { bold: true, size: 20, color: "111827" },
        paragraph: { spacing: { before: 140, after: 80 } },
      },
    },
  },
  tableCellOverrides: {
    margins: {
      top: 115,
      right: 115,
      bottom: 115,
      left: 115,
    },
  },
  tableOverrides: {
    width: {
      size: 100,
      type: "pct",
    },
    layout: "fixed",
    borders: {
      top: TABLE_BORDER,
      right: TABLE_BORDER,
      bottom: TABLE_BORDER,
      left: TABLE_BORDER,
      insideHorizontal: TABLE_BORDER,
      insideVertical: TABLE_BORDER,
    },
  },
  textRunOverrides: {
    ...DOCX_TEXT_RUN,
  },
} as const satisfies TiptapSharedExportOptions;
